export default "__VITE_ASSET__DexV9bU1__"